class GoogleTokenManager {
  constructor() {
    this.refreshTimer = null;
  }

  // Refrescar token de Google
  async refreshGoogleToken(refreshToken) {
    // Simular fallo en modo test
    if (localStorage.getItem('simulateGoogleFailure') === 'true') {
      console.log('🧪 Simulando fallo de Google token refresh');
      throw new Error('Simulated Google refresh failure');
    }
    
    try {
      const response = await fetch('https://oauth2.googleapis.com/token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          refresh_token: refreshToken,
          grant_type: 'refresh_token'
        })
      });

      if (!response.ok) throw new Error('Failed to refresh token');
      
      const data = await response.json();
      return {
        access_token: data.access_token,
        expires_in: data.expires_in || 3600
      };
    } catch (error) {
      console.error('Error refreshing Google token:', error);
      throw error;
    }
  }

  // Programar refresh automático
  scheduleTokenRefresh(refreshToken, expiresIn = 3600) {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
    }

    // Refrescar 10 minutos antes de que expire (más conservador)
    const refreshTime = Math.max((expiresIn - 600) * 1000, 300000); // Mínimo 5 minutos
    
    console.log(`🔄 Programando refresh de Google token en ${refreshTime/1000/60} minutos`);
    
    this.refreshTimer = setTimeout(async () => {
      try {
        const newToken = await this.refreshGoogleToken(refreshToken);
        
        // Actualizar token en localStorage
        localStorage.setItem('googleAccessToken', newToken.access_token);
        
        // Programar siguiente refresh
        this.scheduleTokenRefresh(refreshToken, newToken.expires_in);
        
        console.log('✅ Google token refreshed successfully');
      } catch (error) {
        console.error('❌ Failed to refresh Google token:', error);
        
        // Intentar una vez más en 5 minutos
        setTimeout(() => {
          this.scheduleTokenRefresh(refreshToken, 300); // Reintentar en 5 min
        }, 300000);
        
        console.warn('⚠️ Google token refresh failed, reintentando en 5 minutos');
      }
    }, refreshTime);
  }

  // Limpiar timers
  clearRefreshTimer() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = null;
    }
  }
}

const googleTokenManager = new GoogleTokenManager();
export default googleTokenManager;